import { MatrixCellInterface } from "@swivl-mono/types";
import * as React from "react";
import { FaPlus } from "react-icons/fa";

import { QuestsModel, WorkflowsJourney } from "../../../../../Models/Quests/Quests.Model";
import "./MatrixQuestLabel.scss";
import MatrixQuestMenu from "./MatrixQuestMenu";

interface Props {
  // delegate: MatrixView,
  item: MatrixCellInterface;
  // focus: {x:any, y:any},
  // x:number,
  // y:number
  workflows: WorkflowsJourney[];
  // matrix: MatrixQuestInterface
  showMenu: boolean;
  toggleMenu(e);
  setQuest(questSlug);
  setShowMenu(showMenu);
  canEdit: boolean;
}

export default class MatrixQuestLabel extends React.Component<Props> {
  constructor(props) {
    super(props);
    this.state = { showMenu: true };
    this.valueChanged = this.valueChanged.bind(this);
    this.deleteClicked = this.deleteClicked.bind(this);
  }

  valueChanged() {}

  deleteClicked() {}

  render() {
    let title: any = this.props.item.quest ? QuestsModel.nameForQuest(this.props.item.quest) : null;
    if (!title) {
      title = (
        <span>
          <FaPlus /> Set Quest
        </span>
      );
    }
    const className = title && title.length > 0 ? "MatrixQuestLabel" : "MatrixQuestLabel noQuest";

    if (!this.props.canEdit) {
      return (
        <div className={className}>
          <div className="quest">{title}</div>
        </div>
      );
    }

    const menu = this.props.showMenu ? (
      <MatrixQuestMenu workflows={this.props.workflows} setQuest={this.props.setQuest} setShowMenu={this.props.setShowMenu} />
    ) : null;
    return (
      <div className={className}>
        <div className="quest font-poppins font-semibold" onClick={this.props.toggleMenu}>
          {title}
        </div>
        {menu}
      </div>
    );
  }
}
